import React, { FunctionComponent } from 'react';

import { css } from '@emotion/react';

interface Props {
  label: string;
  checked: boolean;
  value: string | number;
  handleChecked: () => void;
}

const Checkbox: FunctionComponent<Props> = ({
  label,
  checked,
  value,
  handleChecked,
}) => {
  return (
    <label css={container(checked)}>
      <input
        css={inputs}
        type="checkbox"
        id={`custom-checkbox-${label}-${value}`}
        checked={checked}
        onChange={handleChecked}
      />
      <img
        css={[imgs, label === '' && { marginRight: 0 }]}
        src={
          checked ? '/assets/icons/check_on.svg' : '/assets/icons/check_off.svg'
        }
        alt="checkbox"
      />
      {label}
    </label>
  );
};

export default Checkbox;

const container = (checked: boolean) => css`
  width: fit-content;
  display: flex;
  align-items: center;
  font-size: 14px;
  line-height: 14px;
  color: ${checked ? '#222' : 'grey'};
  height: 20px;
  cursor: pointer;
`;

const inputs = css`
  appearance: none;
`;

const imgs = css`
  width: 20px;
  height: 20px;
  margin-right: 6px;
`;
